export default __webpack_public_path__ + "static/media/x-circle.64ff22c9.svg";